import {getRequest} from '@services/api/axiosHandler'
import {getArticles} from '@services/articles/centralHandler'
import store from '@store'
import unitAirvolumes from "@services/calculations/index";

import Project from '@models/project/Project'
import Configuration from '@models/project/Configuration'

import Roomtype from '@models/helpers/Roomtype'
import RoomtypeAt from '@models/helpers/RoomtypeAt'
import LtmHasRoomtype from '@models/helpers/LtmHasRoomtype'
import LtmHasRoomtypeAt from '@models/helpers/LtmHasRoomtypeAt'
import Ltm from '@models/helpers/Ltm'
import LtmAt from '@models/helpers/LtmAt'
import LtmHasRoomtypeHasRoomltm from '@models/helpers/LtmHasRoomtypeHasRoomltm'
import LtmHasRoomtypeHasRoomltmAt from '@models/helpers/LtmHasRoomtypeHasRoomltmAt'
import Roomltm from '@models/helpers/Roomltm'
import RoomltmAt from '@models/helpers/RoomltmAt'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'
import Operationmode from '@models/helpers/Operationmode'
import OperationmodeAt from '@models/helpers/OperationmodeAt'
import RoomltmsHasOperationmode from '@models/helpers/RoomltmsHasOperationmode'
import RoomltmsHasOperationmodeAt from '@models/helpers/RoomltmsHasOperationmodeAt'
import RoomtypesHasLtmsHasOperationmodesHasDevicepackage
  from '@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackage'


export const getInitializationData = async function () {
  getArticles()
  const response = await getRequest('initialization/' + document.documentElement.lang)

  const globalData = response.data.globalData
  const dbValues = response.data.dbValues

  this.$store.state.session.registrationLink = response.data.registrationLink
  this.$store.state.session.passwordLink = response.data.passwordLink
  this.$store.state.session.myAccountLink = response.data.myAccountLink
  this.$store.state.session.norms = response.data.norms
  this.$store.state.localization.values = globalData

  // change article image url. Remove slash at the end of the url if exists and add _72dpi/ to the end of the url
  this.$store.state.localization.articleImageUrl = globalData.image_path
  this.$store.state.localization.articleDatasheetUrl = globalData.datasheet_path
  this.$store.state.localization.selectUrl = globalData.select_path
  this.$store.state.constants.values = dbValues.Constants

  Roomtype.deleteAll()
  RoomtypeAt.deleteAll()
  Ltm.deleteAll()
  LtmAt.deleteAll()
  LtmHasRoomtype.deleteAll()
  LtmHasRoomtypeAt.deleteAll()
  LtmHasRoomtypeHasRoomltm.deleteAll()
  LtmHasRoomtypeHasRoomltmAt.deleteAll()
  Roomltm.deleteAll()
  RoomltmAt.deleteAll()
  /*  RoomtypesHasOperationmodesHasAirvolume.deleteAll()
    RoomtypesHasOperationmodesHasAirvolumeAt.deleteAll()*/
  Operationmode.deleteAll()
  OperationmodeAt.deleteAll()
  RoomltmsHasOperationmode.deleteAll()
  RoomltmsHasOperationmodeAt.deleteAll()
  /*  RoomtypesHasLtmsHasOperationmodesHasDevicepackage.deleteAll()
    RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt.deleteAll()*/

  Roomtype.create({
    data: dbValues.Roomtypes,
  })
  RoomtypeAt.create({
    data: dbValues.RoomtypesAt,
  })
  Ltm.create({
    data: dbValues.Ltm,
  })
  LtmHasRoomtype.create({
    data: dbValues.LtmHasRoomtypes,
  })
  LtmAt.create({
    data: dbValues.LtmAt,
  })
  LtmHasRoomtypeAt.create({
    data: dbValues.LtmHasRoomtypesAt,
  })
  Roomltm.create({
    data: dbValues.Roomltms,
  })
  RoomltmAt.create({
    data: dbValues.RoomltmsAt,
  })
  LtmHasRoomtypeHasRoomltm.create({
    data: dbValues.LtmsHasRoomtypesHasRoomltm,
  })
  LtmHasRoomtypeHasRoomltmAt.create({
    data: dbValues.LtmsHasRoomtypesHasRoomltmAt,
  })
  Operationmode.create({
    data: dbValues.Operationmode,
  })
  OperationmodeAt.create({
    data: dbValues.OperationmodeAt,
  })
  RoomltmsHasOperationmode.create({
    data: dbValues.RoomltmsHasOperationmode,
  })
  RoomltmsHasOperationmodeAt.create({
    data: dbValues.RoomltmsHasOperationmodeAt,
  })
  /*  RoomtypesHasOperationmodesHasAirvolume.create({
      data: dbValues.RoomtypesHasOperationmodesHasAirvolume,
    })
    RoomtypesHasOperationmodesHasAirvolumeAt.create({
      data: dbValues.RoomtypesHasOperationmodesHasAirvolumeAt,
    })
    RoomtypesHasLtmsHasOperationmodesHasDevicepackage.create({
      data: dbValues.RoomPossebilities,
    })
    RoomtypesHasLtmsHasOperationmodesHasDevicepackageAt.create({
      data: dbValues.RoomPossebilitiesAt,
    })*/

  let configurations = Configuration.query().get()
  if (configurations.length <= 0) {
    Project.insertOrUpdate({
      data: {
        selectedProject: true,
        country: store.state.User.country.country_id,
        contact: [
          {
            type: 1,
          },
        ],
        configurations: [
          {
            selectedConfiguration: true,
          },
        ],
      },
      create: ['configurations'],
    })
  }
}
export const devicePackageData = async function () {

  if (
    RoomtypesHasOperationmodesHasAirvolume.query().get().length > 0 &&
    RoomtypesHasLtmsHasOperationmodesHasDevicepackage.query().get().length > 0
  ) {
    await unitAirvolumes.calculate()
    return true;
  }

  const configuration = Configuration.query().first()

  await RoomtypesHasOperationmodesHasAirvolume.deleteAll()
  await RoomtypesHasLtmsHasOperationmodesHasDevicepackage.deleteAll()

  const response = await getRequest('initialization/device-package/' + configuration.norms_id)

  await RoomtypesHasOperationmodesHasAirvolume.create({
    data: response.data.RoomtypesHasOperationmodesHasAirvolume,
  })
  await RoomtypesHasLtmsHasOperationmodesHasDevicepackage.create({
    data: response.data.RoomPossebilities,
  })
  await unitAirvolumes.calculate()
  return true;

}
